/**
 * Tailwind classes for `DeniedState`, built only from the tokens in
 * `src/styles/globals.css`.
 *
 * Deliberately NOT `text-critical`. A refusal is a correct answer from the
 * system, not a fault, and painting it red teaches operators to look for
 * something broken — so they retry, escalate, or blame their own session.
 */
export const deniedStateStyles = {
  root: 'flex flex-col items-center justify-center gap-2 rounded-surface border border-border bg-surface-raised px-6 py-10 text-center',
  title: 'text-sm font-medium text-content',
  message: 'text-sm text-content-muted',
  description: 'text-sm text-content-subtle',
} as const;
